// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1258":"ed38d915b5d20bf0","2888":"191ccf204361a6df"}[chunkId] + ".css";
};